import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/promote/share-embed")({
  // Component in lazy file for code splitting
});
